/**
 * Returns the next day of the week given the current day.
 * @param {Hours} hours - The hours of operation for the location.
 * @param {string} currentDay - The current day of the week (e.g., 'monday').
 * @returns {string} - The next day of the week.
 */
export const getNextDay = (hours, currentDay) => {
	const allClosed = Object.values(hours).every((time) => time === 'Closed');
	if (allClosed) return '';
	const daysOfWeek = [
		'sunday',
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday'
	];
	const currentIndex = daysOfWeek.indexOf(currentDay.toLowerCase());
	const nextIndex = (currentIndex + 1) % daysOfWeek.length;
	let nextDay = daysOfWeek[nextIndex];
	// If the next day is closed, keep moving to the next day until we find an open day
	if (hours[nextDay].toLowerCase() === 'closed') {
		nextDay = getNextDay(hours, nextDay);
	}
	return nextDay;
};
